import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestAddchg } from "../../entity/EntityRequestAddchg";

export class DtoRequestAddchgsGetReq extends EntityRequestAddchg {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_request_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
